
import { size } from '@styles/theme'
import styled from '@emotion/styled'

import { ButtonGroup } from '@mui/material'

// const drawerHeight = '85dvh'
const tabHeight = size(0.5)
const tabMargin = size(2) // *2 for top and bottom
const tabTotalHeight = size(4.5)
const drawerHeaderHeight = size(6)

const drawerDimensions = {
  // drawerHeight,
  tabHeight,
  tabMargin,
  tabTotalHeight,
  drawerHeaderHeight,
}

const GreyedTextStyles = `
  font-weight: 500;
  color: grey;
  letter-spacing: 0.5px;
`

const DrawerBackground = styled.div`
  min-height: 30dvh;
  max-height: 100dvh;
  width: 100dvw;
  border-radius: 25px 25px 0 0;
  background-color: rgba(0,0,0,0.85);
  backdrop-filter: blur(10px);
  padding-bottom: ${size(1)};
`

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${tabMargin};
  padding-bottom: ${tabMargin};
  widht: 100%;
  fle-shrink: 0;
`

const DrawerTab = styled.div`
  width: ${size(6)};
  height: ${tabHeight};
  border-radius: 100px;
  background-color: grey;
  flex-shrink: 0;
`

const MuiButtonGroup = styled(ButtonGroup)`
  width: 100%;
  padding: 0 ${size(3)} ${size(1.5)} ${size(3)};

  button {
    border: 0.5px solid rgba(255,255,255, 0.15) !important;
    border-top: none !important;
  }
    
  & > button:first-of-type {
    border-top: 0.5px solid rgba(255,255,255, 0.15) !important;
  }
`

const DrawerContents = ({ slotProps={ background: {}, tab: {} }, children }) => {
  return (
    <DrawerBackground {...slotProps?.background || {}}>
      <TabContainer>
        <DrawerTab {...slotProps?.tab || {}}/>
      </TabContainer>
      {children}
    </DrawerBackground>
  )
}

// DRAWER BUTTON GROUP
const DrawerButtonGroup = ({ children, ...rest }) => (
  <MuiButtonGroup
    orientation='vertical'
    variant='contained'
    {...rest}>
    {children}
  </MuiButtonGroup>
)

export {
  DrawerContents,
  DrawerButtonGroup,
  GreyedTextStyles
}
